import customAxios from './axios';
import CONFIG from '../../config';

export const createAdditionalPayments = (payload) => {
    return customAxios.post( CONFIG.apiURL + '/AdditionalPaymentType/Create', payload).then(res => {
        return res;
    });
};

export const getAllAdditionalPayments = () => {
    return customAxios.get(CONFIG.apiURL + '/AdditionalPaymentTypes').then(res => {
        let response = res['data'];
        return response;
    });
};

export const additionalPaymentRequests = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentRequests/GetByJob?jobId=${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllAdditionalJobStatuses = () => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentRequests/GetAllAdditionalJobStatuses`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateStatus = (payload) => {
    return customAxios.put( CONFIG.apiURL + `/AdditionalPaymentRequests/UpdateStatus`, payload).then(res => {
        return res;
    });
};

export const getUpdate = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentType/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateAdditionalPayment = (payload) => {
    return customAxios.put( CONFIG.apiURL + `/AdditionalPaymentType/Update`, payload).then(res => {
        return res;
    });
};

export const updateAdditionalPaymentReference = (payload) => {
    return customAxios.put( CONFIG.apiURL + `/AdditionalPaymentReferences/UpdateStatus`, payload).then(res => {
        return res;
    });
};

export const statusLogs = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentLogsById/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const additionalPaymentWithFilter = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/AdditionalPaymentRequests/GetAllWithFilter`, payload).then(res => {
        return res['data'];
    });
}



